import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';
import Global from 'models/Global';
import SessionGroup from './SessionGroup';
import '../backbone-relational-isomorphic';

var SessionsGroupCollection = Backbone.Collection.extend({

    model: SessionGroup,

    initialize: function() {
    }

});

export default SessionsGroupCollection;

